import { GridMapper } from "@/features/ui/grid-row/gird-mapper";
import { LightLineSheetSet } from "@/features/line-sheet-sets/line-sheet-set.types";
import { AgencyLineSheetSetRow } from "@/features/order-sheet-sets/line-sheet-set-row.type";

export const lineSheetSetMapper = new GridMapper<
  LightLineSheetSet,
  AgencyLineSheetSetRow
>(
  "LineSheetSet",
  (lineSheetSet) => {
    return {
      id: lineSheetSet.id,
      season: lineSheetSet.season,
      name: lineSheetSet.name,
      status: lineSheetSet.status,
      reviewStatus: lineSheetSet.reviewStatus,
      compressionStatus: lineSheetSet.compressionStatus,
      type: lineSheetSet.type,
      publishedAt: lineSheetSet.publishedAt,
      validUntil: lineSheetSet.validUntil,
      createdAt: lineSheetSet.createdAt,
      issuedByBoutique: lineSheetSet.issuedByBoutique,
      brands: lineSheetSet.brands,
      compressedImportedFile: lineSheetSet.compressedImportedFile,
      compressedUnoFormFile: lineSheetSet.compressedUnoFormFile,
      unoFormFile: lineSheetSet.unoFormFile,
      confirmedAmount: 0,
      confirmedQuantity: 0,
      orderedAmount: lineSheetSet.orderedAmount ?? 0,
      orderedQuantity: lineSheetSet.orderedQuantity ?? 0,
      orderedOrderCount: lineSheetSet.orderedOrderCount ?? 0,
      currency: lineSheetSet.currency ?? "EUR",
      moq: lineSheetSet.moq ?? null,
      orderRules: lineSheetSet.orderRules,
      externalFileLinks: lineSheetSet.externalFileLinks,
      isDeleted: lineSheetSet.isDeleted,
      aiImageCompletedAt: lineSheetSet.aiImageCompletedAt,
      applyConditionCompletedAt: lineSheetSet.applyConditionCompletedAt,
      orderRuleStatus: lineSheetSet.orderRuleStatus,
      orderRuleFiles: lineSheetSet.orderRuleFiles,
    };
  },
  (lineSheetSetRow) => {
    return {
      id: lineSheetSetRow.id,
      season: lineSheetSetRow.season,
      name: lineSheetSetRow.name,
      status: lineSheetSetRow.status,
      reviewStatus: lineSheetSetRow.reviewStatus,
      compressionStatus: lineSheetSetRow.compressionStatus,
      type: lineSheetSetRow.type,
      publishedAt: lineSheetSetRow.publishedAt,
      validUntil: lineSheetSetRow.validUntil,
      createdAt: lineSheetSetRow.createdAt,
      issuedByBoutique: lineSheetSetRow.issuedByBoutique,
      brands: lineSheetSetRow.brands,
      compressedImportedFile: lineSheetSetRow.compressedImportedFile,
      compressedUnoFormFile: lineSheetSetRow.compressedUnoFormFile,
      unoFormFile: lineSheetSetRow.unoFormFile,
      orderRules: lineSheetSetRow.orderRules,
      externalFileLinks: lineSheetSetRow.externalFileLinks,
      isDeleted: lineSheetSetRow.isDeleted,
      aiImageCompletedAt: lineSheetSetRow.aiImageCompletedAt,
      applyConditionCompletedAt: lineSheetSetRow.applyConditionCompletedAt,
      orderRuleStatus: lineSheetSetRow.orderRuleStatus,
    };
  }
);
